<div>
    <div class="fixed-page-title">
        <div class="page-header">
            <div>
                <p class="page-title">
                    {{resourceKeyValue.deviceTypesPageTitle}}
                </p>
            </div>
            <div>
                <button class="btn btn-primary float-right" id="btnCreateDevice"
                    [routerLink]="['add-device-type']">{{resourceKeyValue.btnCreateDeviceType}}</button>
            </div>
        </div>
    </div>
    <div class="form-title padding-top-4em">
        <div content id="searchDeviceTypesForm" class="w-100" [formGroup]="searchDeviceTypesForm">
            <div class="form-group">
                <div class="input-group mb-2 tertiary-search w-100">
                    <div class="has-clear w-100">
                        <input type="text" class="form-control w-25" id="term"
                            placeholder={{resourceKeyValue.searchByDeviceTypeName}} formControlName="term"
                            (keyup)="search($event.target.value)">
                    </div>
                    <span class="input-group-append">
                        <div class="input-group-text btn-tertiary-search border-0"><i class="icon-search-bold"></i>
                        </div>
                    </span>
                </div>

            </div>
        </div>
    </div>
    <div *ngIf="!isLoading">
        <div class="table-responsive">
            <table id="deviceTypeTable" class="table table-striped table-hover" #deviceTypeTable>
                <thead class="column-sort">
                    <tr>
                        <th (click)="sortableState ='1'; isDefaultSort=false"
                            [ngClass]="[sortableState == '1' ? 'sorting':'' ,isDefaultSort==true ? 'sorted-asc':'',deviceTypes?.length===0?'disabled-header':'']"
                            scope="col" [appSort]="deviceTypes" data-order="desc" data-name="name" tabindex="0"
                            class="tabfocusable initialSort w-20">
                            <span>{{resourceKeyValue.gridHeaderDeviceTypeName}}</span>
                        </th>
                        <th (click)="sortableState ='2'"
                            [ngClass]="{'sorting':sortableState == '2','disabled-header':deviceTypes?.length===0}"
                            scope="col" [appSort]="deviceTypes" data-order="desc" data-name="code" tabindex="0"
                            class="tabfocusable w-10">
                            <span>{{resourceKeyValue.gridHeaderDeviceTypeCode}}</span>
                        </th>
                        <th (click)="sortableState ='3'"
                            [ngClass]="{'sorting':sortableState == '3','disabled-header':deviceTypes?.length===0}"
                            scope="col" [appSort]="deviceTypes" data-order="desc" data-name="deviceModelsCount" tabindex="0"
                            class="tabfocusable w-10">
                            <span>{{resourceKeyValue.gridHeaderDeviceModelsCount}}</span>
                        </th>
                        <th [ngClass]="{'disabled-header':deviceTypes?.length===0}" scope="col" class="text-right"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let deviceType of deviceTypes | slice: (pageIndex-1) * pageSize : pageIndex * pageSize; index as i">
                        <td scope="row">{{deviceType.name}}</td>
                        <td scope="row">{{deviceType.code}}</td>
                        <td scope="row">{{deviceType.deviceModelsCount}}</td>
                        <td scope="row" class="text-right">
                            <button class="btn btn-sm btn-secondary"
                                [routerLink]="['edit-device-type',deviceType.id]">{{resourceKeyValue.edit}}</button>
                        </td>
                    </tr>
                    <tr *ngIf="deviceTypes?.length===0">
                        <td colspan="7" class="empty-grid">
                            <p class="empty-grid-header">{{resourceKeyValue.noDataAvailable}}</p>
                            <p class="empty-grid-body-text">{{resourceKeyValue.gridNoDeviceTypeDetails}}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="table-footer" *ngIf="deviceTypes?.length>0">
            <div id="pagination" style="display: block;">
                {{resourceKeyValue.page}} <b>{{pageIndex}}</b> {{resourceKeyValue.of}} {{numberOfPages}}
            </div>
            <div class="rpp">
                <span>{{resourceKeyValue.showRows}}</span>
                <div class="dropdown dropdown-sm" role="navigation">
                    <button class="btn btn-sm dropdown-toggle" type="button" data-toggle="dropdown" id="pagination"
                        aria-haspopup="true" aria-expanded="false"
                        aria-controls="dropdownPagination">{{pageSizeDisplay}}</button>
                    <div class="dropdown-menu" aria-labelledby="pagination" id="dropdownPagination">
                        <ng-container *ngFor="let page of pageSizeOptions">
                            <button *ngIf='isNumber(page)'
                                (click)="pageSizeDisplay=page; pageSize=page; refreshDeviceTypes();" role="menuitem"
                                ngbDropdownItem>{{page}}</button>
                            <button *ngIf='!isNumber(page)'
                                (click)="pageSizeDisplay=page.showAll; pageSize=deviceTypes?.length; refreshDeviceTypes();"
                                role="menuitem" ngbDropdownItem>{{page.showAll}}</button>
                        </ng-container>
                    </div>
                </div>
            </div>
            <ngb-pagination class="d-flex justify-content-end" [boundaryLinks]="true" [collectionSize]="totalNumber"
                [(page)]="pageIndex" [maxSize]=5 [pageSize]="pageSize">
            </ngb-pagination>
        </div>
    </div>
</div>
<app-loader [isLoading]=isLoading></app-loader>